import { queryOptions } from "@tanstack/react-query";
import { getBlogIndexFn, getBlogPostFn, listAdminBlogPostsFn, getAdminBlogPostFn } from "./blog.functions";
import type { BlogIndexData, BlogPost, BlogPostDetail } from "./types";

export const blogIndexQuery = () =>
  queryOptions({
    queryKey: ["blog", "index"],
    queryFn: () => getBlogIndexFn() as Promise<BlogIndexData>,
    staleTime: 30_000,
  });

export const blogPostQuery = (slug: string) =>
  queryOptions({
    queryKey: ["blog", "post", slug],
    queryFn: () => getBlogPostFn({ data: { slug } }) as Promise<BlogPostDetail | null>,
    staleTime: 30_000,
  });

export const adminBlogPostsQuery = () =>
  queryOptions({
    queryKey: ["blog", "admin", "list"],
    queryFn: () => listAdminBlogPostsFn() as Promise<BlogIndexData>,
    staleTime: 0,
  });

export const adminBlogPostQuery = (id: string) =>
  queryOptions({
    queryKey: ["blog", "admin", "post", id],
    queryFn: () => getAdminBlogPostFn({ data: { id } }) as Promise<BlogPost | null>,
    staleTime: 0,
    enabled: id !== "new",
  });